<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-card>
      <v-card-title style="height: 64px">
        <span class="title pl-2">{{institution.name}}</span>
        <span class="grey--text px-2" v-if="editing">正在编辑</span>
        <v-spacer></v-spacer>
        <v-btn @click="goReadonly()" color="primary" flat v-if="editing">返回</v-btn>
      </v-card-title>
      <v-card-text>
        <v-container class="py-0" fluid grid-list-md>
          <v-form ref="institution">
            <v-layout wrap>
              <v-flex sm8 xs12>
                <v-text-field
                  label="机构名称"
                  prepend-icon="$vuetify.icons.institution"
                  v-model="institution.name"
                ></v-text-field>
              </v-flex>
              <v-flex sm4 xs12>
                <v-text-field
                  label="机构机构代码"
                  prepend-icon="$vuetify.icons.levelCode"
                  v-model="institution.code"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  :rows="1"
                  auto-grow
                  label="机构描述"
                  prepend-icon="$vuetify.icons.description"
                  v-model="institution.description"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout class="mt-2 text-xs-right">
      <v-flex v-if="newItem">
        <v-btn :loading="submitLoading" @click="setInstitution(institution)" class="mx-0" color="primary">提交</v-btn>
      </v-flex>
      <v-flex v-if="editing" xs12>
        <v-btn
          :loading="submitLoading"
          @click="setInstitution(institution)"
          class="mx-0"
          color="primary"
        >提交更改
        </v-btn>
      </v-flex>
    </v-layout>

  </l-layout>
</template>

<script>
import {Institution} from '../../../object'

export default {
  name: 'institutionForm',
  props: {
    institution: {
      type: Object,
      default: () => new Institution()
    }
  },
  data: () => ({
    submitLoading: false,
  }),
  computed: {
    newItem () {
      return this.$route.name === 'NewInstitution'
    },
    editing () {
      return this.$route.name === 'EditInstitution'
    }
  },
  methods: {
    async setInstitution (institution) {
      this.submitLoading = true
      try {
        await this.$store.dispatch('userAdmin/setInstitution', institution)
        this.$L.alert('success', '提交成功')
        await this.$L.tab.close(this.$L.tab.current, false)
        this.$router.push({
          name: 'InstitutionList',
          params: {refresh: true}
        })
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.submitLoading = false
      }
    },
    goReadonly () {
      this.$store.dispatch('L/routerInTab').then(() => {
        this.$router.replace({
          name: 'InstitutionDetails',
          params: this.$route.params,
          query: this.$route.query
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
